(function() {
  'use strict';

  angular
    .module('traineeWebApp.dashboard')
    .controller('SwitchAccountsCtrl', SwitchAccountsCtrl);

  SwitchAccountsCtrl.$inject = ['$scope', 'gettext', 'translationService', '$http', '$window', '$modalInstance', 'dashboardResource', 'mtypes'];

  function SwitchAccountsCtrl($scope, gettext, translationService, $http, $window, $modalInstance, dashboardResource, mtypes) {
      var translate = translationService.sprintf;
      var roleMap = {};
      Object.keys(mtypes.userRole).forEach(function(key) {
        roleMap[mtypes.userRole[key]] = gettext(key);
      });

      $scope.formSelection = {
        account: 0
      };

      $scope.setup = {
        accounts: [],
        loaded: false,
        init: getAssociatedAccounts(),
        title: gettext('Switch Accounts'),
        closeButton: { label: gettext('Done'), cssClass: 'btn-info', result: 'dismiss' }

      };

      $scope.switchAccounts = function() {
        var account = $scope.setup.accounts[$scope.formSelection.account];
        var params = {
          domain: account.domain,
          domainAccountId: account.childAccountId
        };

        if (parseInt($scope.formSelection.account) === 0) {
          return $modalInstance.dismiss();

        }
        else {
          return dashboardResource.switchAccounts({ params: params }, function(response) {
            navigateTo(response);
          });
        }

      };

      function getAssociatedAccounts() {
        return dashboardResource.getAssociatedAccounts(function(response) {
          $scope.setup.accounts = response.accounts;
          $scope.setup.accounts.forEach(function(account) {
            account.permissionsName = dashboardResource.capitalize(roleMap[account.permissions]);
          });
          $scope.setup.loaded = true;
        });
      }


      function navigateTo(url) {
        $window.location.href = url;
      }

      $scope.isDesktop = function isDesktop() {
        var $$window = angular.element(window);
        return $$window.width() > 720;
      }
    }
})();